module.exports = __webpack_public_path__ + "static/img/logo14.07aab8ed.png";